module.exports = "<p style=\"font-size:12px;color:#787878;margin-top:4px\">本文经「原本」原创认证，作者__author_name__，访问yuanben.io查询【<a\n    href=\"__article_url__\" target=\"_blank\" style=\"text-decoration:none;color:#007f69\">__short_id__</a>】获取授权信息。</p>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/services/badge/badge-text.html
// module id = 1201
// module chunks = 3